import React from 'react';
import PanelHelpBadge from '../../PanelHelpBadge';

function Stat({ label, value }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900">
      <p className="text-xs text-slate-500 dark:text-slate-400">{label}</p>
      <p className="mt-1 text-xl font-black text-slate-900 dark:text-white">{value}</p>
    </div>
  );
}

export default function DecisionFeedbackCard({ decisionFeedback, onOpenDrawer }) {
  const counts = decisionFeedback?.counts || {};
  const rates = decisionFeedback?.rates || {};
  const comparison = decisionFeedback?.comparison || {};

  const pct = (n) => `${Number(n || 0).toLocaleString('tr-TR')}%`;

  return (
    <section className="min-h-[248px] rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-black text-slate-900 dark:text-white">Karar Geri Bildirimi</h3>
          <PanelHelpBadge
            title="Karar Geri Bildirimi"
            description="Öneri kabul, geçiş ve wow sinyallerini karar kalitesi için birlikte okur."
            interpretation="Kabul düşerken geçiş artıyorsa öneri eşleşmesi veya açıklama kalitesi zayıf olabilir."
            metricExample="Birincil kabul düşük, alternatif kabul yüksekse birincil sıralama iyileştirilmeli."
          />
        </div>
        <button
          type="button"
          onClick={() => onOpenDrawer('funnel')}
          className="text-xs font-bold text-primary hover:underline"
        >
          Detaya git →
        </button>
      </div>

      <div className="mt-3 grid grid-cols-2 gap-3">
        <Stat label="Kabul" value={pct(rates.acceptRate)} />
        <Stat label="Geçiş" value={pct(rates.skipRate)} />
        <Stat label="Wow" value={pct(rates.wowRate)} />
        <Stat label="Gösterim" value={Number(counts.shown || 0).toLocaleString('tr-TR')} />
      </div>

      <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs dark:border-slate-800 dark:bg-slate-900">
        <div className="flex items-center justify-between gap-2">
          <span className="text-slate-500 dark:text-slate-400">Birincil vs Alternatif</span>
          <span className="font-bold text-slate-700 dark:text-slate-200">
            {pct(comparison?.firstSuggestion?.acceptRate)} / {pct(comparison?.alternatives?.acceptRate)}
          </span>
        </div>
      </div>
    </section>
  );
}
